import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { NewDropoff } from '../../domain/models/NewDropoff'
import { INewDropoffProvider, INewDropoffRequestParams } from '../../domain/providers/INewDropoffProvider'
import routes from './routes'

class NewDropoffProvider implements INewDropoffProvider {
    public http: AxiosInstance

    constructor(baseURL: string) {
        const config: AxiosRequestConfig = {
            baseURL: `${baseURL}/api/v1`,
            headers: {
                'content-type': 'application/json'
            }
        }
        this.http = axios.create(config)
    }

    async createDropoff(param: NewDropoff, tenantId: string): Promise<string> {
        const { data } = await this.http.post(routes.CREATE_DROPOFF, this.toNewDropofRequestParams(param, tenantId))
        return data.id
    }

    async uploadDropoffPicture(file: File, dropoffId: string): Promise<void> {
        const formData = new FormData()
        formData.append('resource', file)
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const url = routes.UPLOAD_DROPOFF_PICTURE.replace('<dropoff_id>', dropoffId)
        return await this.http.post(url, formData, config)
    }

    private toNewDropofRequestParams(dropoff: NewDropoff, tenantId: string): INewDropoffRequestParams {
        // Api needs days of week from 1 to 7 with 1 being monday.
        let apiDaysOfWeek: number[] = []
        if (dropoff.contact?.openingHours?.daysOfWeek) {
            apiDaysOfWeek = dropoff.contact.openingHours.daysOfWeek.map(day => day === 0 ? 7 : day)
        }
        return {
            contributorEmail: dropoff.creator?.email || '',
            tenantId: tenantId,
            displayName: dropoff.infos?.name || '',
            description: undefined,
            longitude: dropoff.location?.longitude || 0,
            latitude: dropoff.location?.latitude || 0,
            postalAddress: dropoff.location?.line || '',
            zipCode: dropoff.location?.zipCode || '',
            city: dropoff.location?.city || '',
            countryCode: undefined,
            dropOffTypeId: dropoff.infos?.facility?.id || '',
            wasteTypesIds: dropoff.infos?.wasteCategories?.map(type => type.id) || [],
            openingHours: {
                isOpenAllDay: dropoff.contact?.openingHours?.isOpenAllDay || false,
                daysOfWeek: apiDaysOfWeek,
                openCloseTimes: dropoff.contact?.openingHours?.openCloseTimes || [],
                timezone: dropoff.contact?.openingHours?.timezone || ''
            },
            website: dropoff.contact?.website,
            phone: dropoff.contact?.phone ? '+' + dropoff.contact.phone : undefined
        }
    }
}

export default NewDropoffProvider
